import React, { useEffect, useState } from 'react'
import { Typography } from '@pw-tech/omni-ui'
import cn from 'clsx'
import TabButton from './ModernTabs.module.css'
import { groupList } from '@utils/types'
import { useAmbassadorContext } from '@context/context'
import { PROGRAM_TYPE } from '@utils/enum'

interface Tab {
  id: string
  label: string
  content: string
  to: string
  bgImg: string
}

interface TabsProps {
  items: groupList[]
  currentIndex: any
  onChange: (args: any) => void
  btnSize?: string
}
const ModernTabs: React.FC<TabsProps> = ({
  items,
  currentIndex,
  onChange,
  btnSize,
}) => {
  const [activeHeader, setActiveHeader] = useState<any>('')
  const { myProfileValue } = useAmbassadorContext()

  const classNameDiv = (item: groupList) =>
    cn(
      '`px-2 py-2 xl:px-4 2xl:px-6 xl:text-[18px] text-[14px] focus:outline-none',
      {
        [`bg-[#FFF0E7] text-[#5A4BDA] z-10 font-[600] ${TabButton.content}`]:
          activeHeader === item?.orgName,
        [`bg-[#EAECEF] text-[#757575] font-[500] ${TabButton.inactiveTab}`]:
          activeHeader != item?.orgName,
      }
    )

  const filteredItems = React.useMemo(() => {
    const isCampusMeded =
      myProfileValue?.programType === PROGRAM_TYPE.CAMPUS_MEDED

    return items?.filter((item) => item?.allowForCampusMeded === isCampusMeded)
  }, [items, myProfileValue?.programType])

  useEffect(() => {
    if (!items?.length) return

    const filterItemsByProgramType = (
      items: groupList[],
      programType: string | undefined
    ) => {
      return items?.filter((item) => {
        if (item?.allowForCampusMeded === undefined) {
          return true
        }
        if (programType === PROGRAM_TYPE.CAMPUS_MEDED) {
          return item.allowForCampusMeded === true
        }
        return item.allowForCampusMeded === false
      })
    }
    const filteredItems = filterItemsByProgramType(
      items,
      myProfileValue?.programType
    )

    const isCurrentAllowed = filteredItems.some(
      (item) => item?.orgName === currentIndex
    )

    if (filteredItems.length && !isCurrentAllowed) {
      const firstAllowed = filteredItems[0]
      setActiveHeader(firstAllowed?.orgName)
      onChange(firstAllowed)
      return
    }

    setActiveHeader(currentIndex)
  }, [currentIndex, items, myProfileValue?.programType])

  return (
    <>
      <div className={`w-full ml-[18px] relative z-0`}>
        <div className="flex mx-auto gap-3">
          {filteredItems?.map((item: groupList, index: number) => (
            <div key={index}>
              <button
                key={item?.orgName}
                // style={{ zIndex: '1' }}
                onClick={() => onChange(item)}
                className={classNameDiv(item)}
              >
                <Typography
                  variant="subHeading"
                  weight={
                    activeHeader === item?.orgName ? 'semi-bold' : 'medium'
                  }
                  className="flex"
                >
                  <span className={btnSize}> {item?.orgName}</span>
                </Typography>
              </button>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

export default ModernTabs
